export const DIARY_COLORS = {
    dark_red: '#D36A6A',
    light_red: '#F4B6B6',
    dark_blue: '#6F8FCF',
    light_blue: '#BFD6F7',
    dark_green: '#72A66A',
    light_green: '#C5E7C1',
    dark_grey: '#8F8F8F',
    light_grey: '#D9D9D9',
    dark_yellow: '#D4B21F',
    light_yellow: '#F3E28A',
    dark_purple: '#9A7CC6',
    light_purple: '#DCCBF2',
} as const;

export type DiaryColorKey = keyof typeof DIARY_COLORS;

export const DIARY_COLOR_LABELS: Record<DiaryColorKey, string> = {
    dark_red: 'Dark Red',
    light_red: 'Light Red',
    dark_blue: 'Dark Blue',
    light_blue: 'Light Blue',
    dark_green: 'Dark Green',
    light_green: 'Light Green',
    dark_grey: 'Dark Grey',
    light_grey: 'Light Grey',
    dark_yellow: 'Dark Yellow',
    light_yellow: 'Light Yellow',
    dark_purple: 'Dark Purple',
    light_purple: 'Light Purple',
};

/**
 * Returns a text color (white or dark) that contrasts well with the given background hex.
 */
export function getContrastColor(hex: string): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    // Relative luminance formula (sRGB)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.55 ? '#1F2937' : '#FFFFFF';
}
